module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "landing-page"
    }
  }, [_c('Slider', {
    attrs: {
      "slideList": _vm.slideList,
      "bannerImg": _vm.images.bannerImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Sprouter's calling!!")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-block white-block subtitle-white"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.year) + " 25sprout Intern Project")])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-block subtitle-blue"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("新芽 " + _vm._s(_vm.year) + " 實習生計畫 限時招募中")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('.sections-container'),
      expression: "'.sections-container'"
    }],
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.downArrow
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4bf22cae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
// module id = 675
// module chunks = 0